import React, { createContext, useContext } from "react";

import { EnquiryInfo } from "./types";

const EnquiryInfoContext = createContext<EnquiryInfo | null>(null);

export const EnquiryInfoProvider = ({
  value,
  children,
}: {
  value: EnquiryInfo;
  children: React.ReactNode;
}) => {
  return (
    <EnquiryInfoContext.Provider value={value}>
      {children}
    </EnquiryInfoContext.Provider>
  );
};

export const useEnquiryInfoContext = (): EnquiryInfo => {
  const context = useContext(EnquiryInfoContext);

  if (!context)
    throw new Error(
      "useEnquiryInfoContext must be used within a EnquiryInfoProvider",
    );

  return context;
};
